<template>
  <v-container>
    <v-row justify="space-between">
      <v-col cols="8" sm="10">
        <span class="font-weight-light" style="font-size: 16pt">{{ $t('label.assignedAuctions') }}</span>
      </v-col>
    </v-row>

    <v-row justify="start" v-if="showSkeletonLoader">
      <v-col cols="6" lg="3" v-for="n in 4" :key="n">
        <v-skeleton-loader class="mx-auto" max-width="400" type="card"></v-skeleton-loader>
      </v-col>
    </v-row>

    <v-row justify="start" v-if="auctions.length">
      <v-col cols="12" sm="6" md="4" lg="3" xl="2"  v-for="(item, i) in auctions" :key="i">
        <auction-card :auction="item" :loading="cardLoadingStatus[i]" @itemSelected="itemSelected"></auction-card>
      </v-col>
    </v-row>
    <v-row v-else justify="center">
      <h3 v-show="!showSkeletonLoader">{{ $t('message.info.noAuctionsToShow') }}</h3>
    </v-row>

    <v-dialog v-model="isAuctionDetailDialogOpen" max-width="1000" persistent>
      <auction-detail :auctionId="auctionSelected.id" :isActive="isAuctionDetailDialogOpen" @close="isAuctionDetailDialogOpen = false"></auction-detail>
    </v-dialog>

    <v-dialog v-model="isConfirmationAcceptDialogOpen" max-width="500" persistent>
      <confirmation-dialog @confirm="confirmationAccept">
        <span v-html="$t('message.confirmation.acceptAuction', [auctionSelected.title])"></span>
      </confirmation-dialog>
    </v-dialog>

    <v-dialog v-model="isConfirmationRejectDialogOpen" max-width="500" persistent>
      <confirmation-dialog @confirm="confirmationReject" confirmationButtonColor="error">
        <span v-html="$t('message.confirmation.rejectAuction', [auctionSelected.title])"></span>
      </confirmation-dialog>
    </v-dialog>

   <v-dialog v-model="isAuctionChatDialogOpen" max-width="1000" persistent>
      <auction-chat :auctionId="auctionSelected.id" :isActive="isAuctionChatDialogOpen" @close="closeChatDialog"></auction-chat>
    </v-dialog>
  </v-container>
</template>

<script>
import { showMessage } from '../../mixins'
import status from '../../core/Auctions/status'
import AuctionCard from '../../components/Auctions/auctions/AuctionCard'
import AuctionChat from '../../components/Auctions/auctions/AuctionChat'
import AuctionDetail from '../../components/Auctions/auctions/AuctionDetail'
import ConfirmationDialog from '../../components/Shared/ConfirmationDialog'

export default {
  name: 'AssignedAuctionsPage',
  components: { AuctionCard, AuctionDetail, AuctionChat, ConfirmationDialog },
  mixins: [showMessage],
  data: () => ({
    auctions: [],
    showSkeletonLoader: true,
    auctionSelected: {},
    isAuctionDetailDialogOpen: false,
    isConfirmationAcceptDialogOpen: false,
    isConfirmationRejectDialogOpen: false,
    isAuctionChatDialogOpen: false,
    cardLoadingStatus: []
  }),
  methods: {
    getAuctions () {
      this.auctions = []
      this.showSkeletonLoader = true
      this.$proxy.get(`api/auctions?statusIds=${status.ACCEPTANCE_PENDING},${status.EVALUATION_PENDING}&whereIamWinner=true`)
        .then((r) => {
          this.cardLoadingStatus = []
          for (let i = 0; i < r.data.length; i++) {
            this.cardLoadingStatus = [...this.cardLoadingStatus, false]
          }
          r.data = r.data.sort((a, b) => {
            return (a.requiredDateTime < b.requiredDateTime) ? -1 : 1
          })
          this.auctions = r.data
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.showSkeletonLoader = false
        })
    },
    itemSelected (auction, action) {
      this.auctionSelected = Object.assign({}, auction)
      switch (action) {
        case 'detail':
          this.isAuctionDetailDialogOpen = true
          break
        case 'accept':
          this.isConfirmationAcceptDialogOpen = true
          break
        case 'reject':
          this.isConfirmationRejectDialogOpen = true
          break
        case 'chat':
          this.isAuctionChatDialogOpen = true
          break
      }
    },
    confirmationAccept (confirm) {
      this.isConfirmationAcceptDialogOpen = false
      if (confirm) {
        this.acceptAuction()
      }
    },
    confirmationReject (confirm) {
      this.isConfirmationRejectDialogOpen = false
      if (confirm) {
        this.rejectAuction()
      }
    },
    acceptAuction () {
      const i = this.auctions.findIndex(s => s.id === this.auctionSelected.id)
      this.cardLoadingStatus[i] = true
      this.$proxy.post(`api/auctions/${this.auctionSelected.id}/accept`)
        .then((r) => {
          this.showMessage(this.$t('message.success.auctionAccepted'))
          this.getAuctions()
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.cardLoadingStatus[i] = false
        })
    },
    rejectAuction () {
      const i = this.auctions.findIndex(s => s.id === this.auctionSelected.id)
      this.cardLoadingStatus[i] = true
      this.$proxy.post(`api/auctions/${this.auctionSelected.id}/reject`)
        .then((r) => {
          this.showMessage(this.$t('message.success.auctionRejected'))
          this.getAuctions()
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.cardLoadingStatus[i] = false
        })
    },
    closeChatDialog () {
      this.isAuctionChatDialogOpen = false
      this.auctionSelected = {}
    }
  },
  mounted () {
    this.getAuctions()
  }
}
</script>

<style>

</style>
